// TODO: turn these into variables
let apiUrl = '';
let isProd = false;
let isTest = false;
if (
  window.location.hostname.includes('sjkenterprisesapps') ||
  window.location.hostname.includes('prod.')
) {
  isProd = true;
} else if (window.location.hostname === 'test.d2vag8l33rxtc7.amplifyapp.com') {
  isTest = true;
}

if (isProd) {
  apiUrl = 'https://5ydziz503a.execute-api.us-east-2.amazonaws.com/prod';
} else if (isTest) {
  apiUrl = 'https://pshcwjz45m.execute-api.us-east-2.amazonaws.com/test';
} else {
  apiUrl = 'https://mpfbzkpol1.execute-api.us-east-2.amazonaws.com/dev';
}

// Local testing
if (window.location.hostname === 'localhost') {
  apiUrl = 'http://localhost:3030';
  console.log('Api url is pointing at localhost.');
}

console.log(`Env: ${isProd ? 'Production' : isTest ? 'Test' : 'Development'} `);
console.log(`ApiUrl: ${apiUrl}`);

export const apiBaseUrl = apiUrl;

export const apiKey = 'e1J0SBKqlM305CSXcp7yP5j00LG3s04xaz2AsTXl';
export const defaultFrom =
  'SJK ENTERPRISES LLC\\n9925 N ALPINE RD\\nMACHESNEY PARK, IL 61115\\nUnited States';
